var map = {
	"./6/Math/6.NS.1/Lesson10Session4.js": 786,
	"./ResourceDynamic.js": 753,
	"./general/FruitOfTheSpirit.js": 809,
	"./general/MagicEightBall.js": 767,
	"./general/PdfDocument.js": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;